import { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import 'swiper/css';
import 'swiper/css/navigation';
import BookCard from './BookCard';
import { bookCarouselBreakpoints } from '../../utils/carousel';

const BookSection = ({ id, title, books }) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  return (
    <section id={id} className="carousel-section w-full mx-auto px-3 py-3 sm:px-4 scroll-mt-24">
      <div className="carousel-header mb-3 flex items-center justify-between gap-3">
        <h2 className="text-xl font-semibold text-black sm:text-2xl sm:font-bold">{title}</h2>
        <div className="flex items-center gap-2">
          <button
            ref={prevRef}
            className="flex h-10 w-10 items-center justify-center rounded-full border border-gray-300 bg-white transition hover:border-orange-500 hover:bg-orange-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-500"
            aria-label="Previous"
          >
            <FiChevronLeft className="text-lg text-black" />
          </button>
          <button
            ref={nextRef}
            className="flex h-10 w-10 items-center justify-center rounded-full border border-gray-300 bg-white transition hover:border-orange-500 hover:bg-orange-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-500"
            aria-label="Next"
          >
            <FiChevronRight className="text-lg text-black" />
          </button>
        </div>
      </div>
      <Swiper
        watchOverflow
        grabCursor
        breakpointsBase="container"
        modules={[Navigation, Autoplay]}
        spaceBetween={16}
        slidesPerView={1}
        navigation={{
          prevEl: prevRef.current,
          nextEl: nextRef.current,
        }}
        onBeforeInit={(swiper) => {
          swiper.params.navigation.prevEl = prevRef.current;
          swiper.params.navigation.nextEl = nextRef.current;
        }}
        autoplay={books.length > 1 ? { delay: 3500, disableOnInteraction: false, pauseOnMouseEnter: true } : false}
        rewind
        breakpoints={bookCarouselBreakpoints}
        className="book-swiper"
      >
        {books.map((book) => (
          <SwiperSlide key={book.id}>
            <BookCard book={book} />
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default BookSection;
